module.exports = __webpack_public_path__ + "static/media/hotelPipa0.fdd9c1e8.jpg";